import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AchievementsComponent } from 'src/app/view/achievements/achievements.component';
import { AwardsComponent } from 'src/app/view/achievements/awards/awards.component';
import { CbseComponent } from 'src/app/view/achievements/cbse/cbse.component';
import { ExemplaryComponent } from 'src/app/view/achievements/exemplary/exemplary.component';
import { RouterModule, Routes } from '@angular/router';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SharedModule } from '../shared/shared.module';


const route:Routes=[
  {path:'',component:AchievementsComponent,children:[
    {path:'cbse',component:CbseComponent},
    {path:'exemplary',component:ExemplaryComponent},
    {path:'awards',component:AwardsComponent}
  ]}
]
@NgModule({
  declarations: [
    AchievementsComponent,
    CbseComponent,
    ExemplaryComponent,
    AwardsComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(route),
    PdfViewerModule,
    SharedModule
  ]
})
export class AchievementsModule { }
